<template>
    

    <div class="row hp-authentication-page">
        <div class="hp-bg-black-20 hp-bg-color-dark-90 col-lg-6 col-12 mm-none">
            <div class="row hp-image-row h-100 px-8 px-sm-16 px-md-0 pb-32 pb-sm-0 pt-32 pt-md-0">
                <div class="hp-logo-item m-16 m-sm-32 m-md-64 w-auto px-0 col-12">
                    
                </div>

                <div class="col-12 px-0">
                    <div class="row h-100 w-100 mx-0 align-items-center justify-content-center bg-1" style="background-size: cover; background-repeat: no-repeat; background-position: start;">
                        <div class="hp-bg-item text-center mb-32 mb-md-0 px-0 col-12">
                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 400px;">
                                <img src="../assets/img/logo_big.png" alt="" width="120px">
                                <h1 class="titleH" style="text-align: center; color: #fff; font-size: 90px; margin-top: 50px; margin-left: -25px;">aesnap</h1>
                            </div>
                        </div>

                        <div class="hp-text-item text-center col-xl-9 col-12">
                            <h2 class="hp-text-color-blac-100 hp-text-color-dark-0 mx-16 mx-lg-0 mb-16" style="color: #fff;"> </h2>
                            <p class="h4 mb-0 fw-normal hp-text-color-blac-80 hp-text-color-dark-30" style="color: #fff;"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-6 py-sm-64 py-lg-0">
            <div class="row align-items-center justify-content-center h-100 mx-4 mx-sm-n32">
                <div class="col-12 col-md-9 col-xl-7 col-xxxl-5 px-8 px-sm-0 pt-24 pb-48">

                    <!-- <div style="display: flex; justify-content: center; align-items: center;" class="dd-none">

                        <img src="../assets/img/favicon.png" alt="" style="width: 40px; margin-bottom: 5px;" class="dd-none">

                    </div> -->
                    
                    <h1 class="mb-0 mb-sm-24 mainTitle titleH" style="margin-top: 20px; ">Step 2</h1>
                    

                    <form class="mt-32 mb-8" @submit.prevent="step2">
                                <div class="mb-16">
                                    <label for="registerUsername" class="form-label">Date of birth</label>
                                    <input type="date" class="form-control" id="registerUsername" style="padding-top: 5px; padding-bottom: 5px;" placeholder="dd/mm/yy" v-model="dob" required>
                                </div>

                                <div class="mb-16">
                                    <label for="registerEmail" class="form-label">Document type</label>
                                    
                                    <select class="form-select form-select-lg" aria-label=".form-select-lg example" v-model="documentType">
                                        <option value="ninSlip">Nin slip</option>
                                        <option value="ninCard">Nin Card</option>
                                        <option value="passport">International passport</option>
                                        <option value="driver">Driver's license</option>
                                    </select>

                                </div>

                                <div class="mb-16" style="margin-top: 30px;">

                                    <label for="displayName" class="form-label"> Front image of document </label>
                                        
                                    <input type="file" class="form-control" accept="image/*" id="frontImgSelect"
                                        required @change="mediaPreview">
                                    <div id="fileSizeText" class="form-text"><span> Image should not be larger than 20(MB)</span></div>

                                    <img src="" alt="." id="frontImgPre" class="d-none"
                                        style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;">

                                </div>

                                <div class="mb-24" v-if="documentType == 'ninCard' || documentType == 'driver'">

                                    <label for="displayName" class="form-label"> Back image of document</label>
                                    <input type="file" class="form-control" accept="image/*" id="backImgSelect" @change="mediaPreview2">
                                    <div id="fileSizeText2" class="form-text"><span> Image should not be larger than 10(MB)</span></div>

                                    <img src="" alt="." id="backImgPre" class="d-none"
                                        style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;">

                                </div>

                                

                                <button type="submit" class="btn btn-primary w-100" style=" margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                                    Continue
                                </button>
                            </form>

                            <div class="col-12 hp-form-info text-center" style="margin-top: 20px;">
                                <p>Already have an account? <router-link :to="{name: 'sign-in'}" class="hp-text-color-dark-primary-2"  ><strong style="color: #9146ff;" >Sign in</strong></router-link></p>
                                
                            </div>

                    <div class="mt-48 mt-sm-96 col-12">

                        <div class="dd-none" style="margin-top: 100px;"></div>
                        <div class=" divider mt-18 mb-24" ></div>

                        <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                            </p>

                        </div>

                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


</template>

<style scoped>

    .bg-1{
        background-image: url(../assets/img/frontpage-banner-13.png);
    }

</style>

<script>

    import { doc, setDoc, collection, query, where, getDocs, serverTimestamp, addDoc,deleteDoc, updateDoc } from "firebase/firestore"; 
    import {getAuth, createUserWithEmailAndPassword, AuthErrorCodes} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",

                dob: "",
                dobMonth: "",
                dobDay: "",
                dateSecs: "",
                documentType: "ninSlip"

                

            }
        },

        methods:{

            closeE() {
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS() {
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            mediaPreview() {

                if (document.getElementById("frontImgSelect").files[0] == null) {
                    document.getElementById("frontImgPre").classList.add("d-none");
                    return;
                }

                const fileReader = new FileReader();

                fileReader.readAsDataURL(document.getElementById("frontImgSelect").files[0]);
                fileReader.addEventListener("load", function () {

                    document.getElementById("frontImgPre").classList.add("d-none");
                    document.getElementById("frontImgPre").src = this.result;
                    document.getElementById("frontImgPre").classList.remove("d-none");

                });

            },

            mediaPreview2() {

                if (document.getElementById("backImgSelect").files[0] == null) {
                    document.getElementById("backImgPre").classList.add("d-none");
                    return;
                }

                const fileReader = new FileReader();

                fileReader.readAsDataURL(document.getElementById("backImgSelect").files[0]);
                fileReader.addEventListener("load", function () {

                    document.getElementById("backImgPre").classList.add("d-none");
                    document.getElementById("backImgPre").src = this.result;
                    document.getElementById("backImgPre").classList.remove("d-none");

                });

            },

            step2(){

                if(this.documentType == "ninCard" || this.documentType == "driver"){
                    if (document.getElementById("backImgSelect").files[0] == null) {
                        this.errorText = "Please upload the back image of the document to continue";
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    }

                    if ( document.getElementById("backImgSelect").files[0] != null && document.getElementById("frontImgSelect").files[0] > 10971520) {
                        this.errorText = "The image is too large. The image should not be larger than is 10MB";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    }

                }

                if ( document.getElementById("frontImgSelect").files[0] != null && document.getElementById("frontImgSelect").files[0] > 20971520) {
                    this.errorText = "The image is too large. The image should not be larger than is 20MB";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

            }

        }
        
    }
    
</script>